import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class ReportsService {
  constructor(private http: HttpClient) {}

  getProductReport(productId: number, dateFrom: any, dateTo: any) {
    return this.http.get<any[]>(
      `${environment.apiUrl}/api/reports/products/${productId}?date_from=${dateFrom}&date_to=${dateTo}`
    );
  }

  getWorkersReport(userId: number, dateFrom: any, dateTo: any) {
    return this.http.get<any[]>(
      `${environment.apiUrl}/api/reports/users?date_from=${dateFrom}&date_to=${dateTo}&user_id=${userId}`
    );
  }

  getWorkersDelay(userId: number, dateFrom: any, dateTo: any) {
    return this.http.get<any[]>(
      `${environment.apiUrl}/api/reports/delays/user?date_from=${dateFrom}&date_to=${dateTo}&user_id=${userId}`
    );
  }

  getScrapReport(dateFrom: any, dateTo: any) {
    return this.http.get<any[]>(
      `${environment.apiUrl}/api/reports/scraps?date_from=${dateFrom}&date_to=${dateTo}`
    );
  }

  getDelayReport(dateFrom: any, dateTo: any) {
    return this.http.get<any[]>(
      `${environment.apiUrl}/api/reports/delays?date_from=${dateFrom}&date_to=${dateTo}`
    );
  }

  getAllProducts() {
    return this.http.get<any[]>(`${environment.apiUrl}/api/products/dropdown`);
  }

  getAllUsers() {
    return this.http.get<any[]>(`${environment.apiUrl}/api/users?role_id=5`);
  }

  exportProductToPDF(productId: number, dateFrom: any, dateTo: any) {
    return this.http
      .get<any>(
        `${environment.apiUrl}/api/reports/pdf/products/${productId}?date_from=${dateFrom}&date_to=${dateTo}`
      )
      .pipe(
        map((responseData) => {
          return responseData;
        })
      );
  }

  exportWorkersToPDF(userId: number, dateFrom: any, dateTo: any) {
    return this.http
      .get<any>(
        `${environment.apiUrl}/api/reports/pdf/users?date_from=${dateFrom}&date_to=${dateTo}&user_id=${userId}`
      )
      .pipe(
        map((responseData) => {
          return responseData;
        })
      );
  }

  exportWorkerDelayToPDF(userId: number, dateFrom: any, dateTo: any) {
    return this.http
      .get<any>(
        `${environment.apiUrl}/api/reports/pdf/delays/user?date_from=${dateFrom}&date_to=${dateTo}&user_id=${userId}`
      )
      .pipe(
        map((responseData) => {
          return responseData;
        })
      );
  }

  exportProductToCSV(productId: number, dateFrom: any, dateTo: any) {
    return this.http
      .get<any>(
        `${environment.apiUrl}/api/reports/api/reports/exports/active-nips/products/${productId}?date_from=${dateFrom}&date_to=${dateTo}`
      )
      .pipe(
        map((responseData) => {
          return responseData;
        })
      );
  }

  exportScrapToPDF(dateFrom: any, dateTo: any) {
    return this.http
      .get<any>(
        `${environment.apiUrl}/api/reports/pdf/scraps?date_from=${dateFrom}&date_to=${dateTo}`
      )
      .pipe(
        map((responseData) => {
          return responseData;
        })
      );
  }

  exportDelayToPDF(dateFrom: any, dateTo: any) {
    return this.http
      .get<any>(
        `${environment.apiUrl}/api/reports/pdf/delays?date_from=${dateFrom}&date_to=${dateTo}`
      )
      .pipe(
        map((responseData) => {
          return responseData;
        })
      );
  }
}
